import { CompensationReason } from '../enums/CompensationReason';

export interface CompensationReasonOption {
  value: CompensationReason;
  label: string;
  description: string;
}

export const COMPENSATION_REASON_OPTIONS: CompensationReasonOption[] = [
  {
    value: CompensationReason.AttritionPrevention,
    label: 'Attrition prevention',
    description: 'Proactive retention action.',
  },
  {
    value: CompensationReason.CounterOffer,
    label: 'Counter-offer',
    description: 'Reactive retention action.',
  },
  {
    value: CompensationReason.LocationChange,
    label: 'Location change',
    description: 'Compensation recalculation due to a relocation.',
  },
  {
    value: CompensationReason.MarketConditionsChange,
    label: 'Market conditions change',
    description: 'Update in compensation to keep market competitiveness.',
  },
  {
    value: CompensationReason.RegularPerformanceEvaluation,
    label: 'Regular performance evaluation',
    description: 'Compensation adjustment within a performance evaluation context.',
  },
  {
    value: CompensationReason.RoleChange,
    label: 'Role change',
    description: 'Career direction change (e.g.: Manual QA → AQA; Recruiter → PM).',
  },
  {
    value: CompensationReason.SeniorityChange,
    label: 'Seniority change',
    description: 'Seniority changes within the same role or career path.',
  },
  {
    value: CompensationReason.HiringOfferTerms,
    label: 'Hiring offer terms',
    description: 'Pre-negotiated compensation adjustment during the hiring stage.',
  },
  {
    value: CompensationReason.NewHomeRateAdjustment,
    label: 'NewHome rate adjustment',
    description: 'Compensation adjustment within the context of an NH project change.',
  },
  {
    value: CompensationReason.AdminFix,
    label: 'Admin fix',
    description: 'Correction of a mistake in compensation data.',
  },
];
